export default __webpack_public_path__ + "static/media/1_0116.743e2912.webp";